import React from 'react';
import { Link } from 'react-router';

export default class ShapeSetTabSidebar extends React.Component {
  render() {
    const { activeTab, context, organisationId, shapeSetId, shareWithAllIndustries } = this.props;
    const baseUrl = `/${context}/${organisationId}/catchment-sets/${shapeSetId}`;
    return (
      <div className="shape-set-sidebar-section">
          <ul>
            <li className={activeTab === 'ShapeSetDetails' ? 'active' : 'not'}>
              <Link to={baseUrl}>
                Details
              </Link>
            </li>

            { shapeSetId !== 'new' &&
              <span>
                <li
                  className={activeTab === 'ShapeSetShapes' ? 'active' : 'not'}
                  tabIndex="-1"
                >
                  <Link to={`${baseUrl}/shapes`}>
                    Shapes
                  </Link>
                </li>
                { context === 'global' && !shareWithAllIndustries &&
                  <li
                    className={activeTab === 'ShapeSetOrganisations' ? 'active' : 'not'}
                    tabIndex="-1"
                  >
                    <Link to={`${baseUrl}/organisations`}>
                      Organisations
                    </Link>
                  </li>
                }
                { context === 'global' && !shareWithAllIndustries &&
                  <li
                    className={activeTab === 'ShapeSetIndustries' ? 'active' : 'not'}
                    tabIndex="-1"
                  >
                    <Link to={`${baseUrl}/industries`}>
                      Industry
                    </Link>
                  </li>
                }
              </span>
            }
          </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/shapeset/ShapeSetTabSidebar.js